import { useState, useEffect } from 'react';

import WebhooksModel from './WebhooksModel';

export function useWebookEvents({partnerClientId, webhookStatus}) {
    const [webhookEvents, setWebhookEvents] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const onUpdateEvents = async (eventsList) => {
            setWebhookEvents(eventsList);
            setLoading(false);
        };


        const model = new WebhooksModel({
            partnerClientId,
            onUpdateEvents,
            eventParams: {
                webhookStatus
            }
        });

        model.waitForWebhookEventsData();
        setLoading(true);

        return function cleanup() {
            setLoading(false);
            model.stop();
        };

    },
        [webhookStatus, partnerClientId]
    );

    return [loading, webhookEvents];
}
